import { TIcon } from '.';
import { Box } from '@apia/theme';
import { useMemo } from 'react';
import { useIconsListStoreContext } from './store/context';
import { useIconRendererContext } from './context';

export const Icon = (
  props: TIcon & { rowIndex: number; colIndex: number; width: number },
) => {
  const { useProps } = useIconsListStoreContext();

  const ref = useProps<HTMLElement>('cell', {
    columnIndex: props.colIndex,
    rowIndex: props.rowIndex,
  });

  const ContextRenderer = useIconRendererContext();
  const Renderer = props.iconRenderer || ContextRenderer;

  return (
    <Box
      ref={ref}
      role="gridcell"
      data-id={props.id}
      className={`iconsList__iconWrapper ${props.className ?? ''}`}
      aria-label={props.ariaLabel}
      sx={useMemo(
        () => ({
          width: `${props.width}px`,

          '.iconsList__icon__image__wrapper': {
            height: `${props.width - 4}px`,
          },

          '.iconsList__icon__image': {
            maxHeight: `${props.width - 32}px`,
            maxWidth: `${props.width - 32}px`,
          },
        }),
        [props.width],
      )}
      aria-colindex={props.colIndex}
    >
      <Renderer {...props} />
    </Box>
  );
};
